
/**
 * Vacancies listing / filters JS
 */

/* global biro_body */
/* global biro_ajax_spinner */
var $biro_vacancies_filter_distance;
var $biro_location_lat_lng;


// On page load
jQuery( function( $ ) {

	// Init
	$biro_vacancies_filter_distance = $( '#biro-distance' );
	$biro_location_lat_lng          = $( '#biro-location-latlng' );

	// Location input
	biro_body.on( 'change', 'input#biro-location', function( e ) {

		// Init
		const $el = $( this );

		// Empty?
		if ( $el.val().trim() === '' ) {

			// Clear hidden input
			$biro_location_lat_lng.val( '' );

			// Disable distance input
			if ( $biro_vacancies_filter_distance.length ) {
				$biro_vacancies_filter_distance.attr( 'disabled', 'disabled' ).parent( '.vacancy-filter' ).removeClass( 'active' );
			}

		} else {

				// Enable distance input
				if ( $biro_vacancies_filter_distance.length ) {
					$biro_vacancies_filter_distance.removeAttr( 'disabled' ).parent( '.vacancy-filter' ).addClass( 'active' );
				}

		}

	}).on( 'keydown', 'input#biro-location', function( e ) {

		// Stop 'Enter' being pressed to select location from submitting form
		if ( e.which === 13 ) {
			e.preventDefault();
		}

	});

});


/**
 * Google init callback
 */
function biro_vacancies_google_init() {

	// Check for vacancy location fields
	const location      = document.getElementById( 'biro-location' );
	const latlng_hidden = document.getElementById( 'biro-location-latlng' );
	if (
		location !== null &&
		latlng_hidden !== null
	) {

		// Set options
		const options = {
			componentRestrictions: { country: 'uk' },
			fields: [ 'geometry' ],
			types: [ 'geocode' ],
		};

		// Init the autocomplete
		const autocomplete = new google.maps.places.Autocomplete( location, options );

		// When the location is changed
		autocomplete.addListener( 'place_changed', () => {

			// Get lat / lng
			const place = autocomplete.getPlace().geometry;

			// Pass lat / lng to hidden field
			latlng_hidden.value = place.location.lat() + ',' + place.location.lng();

		});

	}

}

